import React from 'react';

export default function Footer(){
    return (
        <div style={{
            bottom: '10px',
        }} className="container">
            <footer className="py-5">
                <div className="row">
                    <div className="col-6 col-md-2 mb-3">
                        <h5>Platform</h5>
                        <ul className="nav flex-column">
                            <li className="nav-item mb-2"><a href="https://easy-street.herokuapp.com/games" className="nav-link p-0 text-muted">Home</a></li>
                            <li className="nav-item mb-2"><a href="https://easy-street.herokuapp.com/" className="nav-link p-0 text-muted">Project</a>
                            </li>
                            <li className="nav-item mb-2"><a href="https://easy-street.herokuapp.com/about" className="nav-link p-0 text-muted">About & Support</a>
                            </li>
                        </ul>
                    </div>

                    <div className="col-6 col-md-2 mb-3">
                        <h5>Developer</h5>
                        <ul className="nav flex-column">
                            <li className="nav-item mb-2"><a href="https://easy-street.herokuapp.com/developer/console" className="nav-link p-0 text-muted">Developer</a></li>
                            <li className="nav-item mb-2"><a href="https://www.youtube.com/watch?v=nTX9NbKgIfw" className="nav-link p-0 text-muted">Guide</a>
                            </li>
                            <li className="nav-item mb-2"><a href="https://easy-street.herokuapp.com/publishers" className="nav-link p-0 text-muted">Partners</a></li>
                            <li className="nav-item mb-2"><a href="https://vertexstudio.herokuapp.com" className="nav-link p-0 text-muted">Vertex Studio</a>
                            </li>
                        </ul>
                    </div>

                    <div className="col-6 col-md-2 mb-3">
                        <h5>Contacts</h5>
                        <ul className="nav flex-column">
                            <li className="nav-item mb-2"><a href="https://www.instagram.com/vertex.studio.games/?hl=en" className="nav-link p-0 text-muted">Instagram</a></li>

                            <li className="nav-item mb-2"><a href="https://t.me/oleksiivv" className="nav-link p-0 text-muted">Telegram</a></li>

                            <li className="nav-item mb-2"><a href="https://www.youtube.com/@EasyStreetVV" className="nav-link p-0 text-muted">Youtube</a></li>

                        </ul>
                    </div>

                    <div className="col-md-5 offset-md-1 mb-3">
                        <form>
                            <h5>Subscribe to our newsletter</h5>
                            <p>Monthly digest of what's new and exciting from us.</p>
                            <div className="d-flex flex-column flex-sm-row w-100 gap-2">
                                <label htmlFor="newsletter1" className="visually-hidden">Email address</label>
                                <input name="subscribe_to_ads_email" id="newsletter1" type="email" className="form-control"
                                       placeholder="Email address"/>
                                        <button className="btn btn-primary" type="button" onClick={(e) => {
                                            e.preventDefault();

                                            let email = document.getElementById("newsletter1").value;
                                            let streetId = 1;

                                            document.getElementById("newsletter1").value = "";

                                            fetch(process.env.REACT_APP_API_URL +  `/ads/${streetId}/subscribe/${email}`, {
                                                method: "POST",
                                                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
                                            }).then(res => res.json())
                                                .then(
                                                    (result) => {},
                                                    (error) => {}
                                                );
                                        }}>Subscribe</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="d-flex flex-column flex-sm-row justify-content-between py-4 my-4 border-top">
                    <p>© 2023 Easy Street, Inc. All rights reserved.</p>
                    <ul className="list-unstyled d-flex">
                        <li className="ms-3"><a className="link-dark" href="https://vertexstudio.herokuapp.com/contacts">
                            <svg className="bi" width="24" height="24">
                            </svg>
                        </a></li>
                        <li className="ms-3"><a className="link-dark" href="https://vertexstudio.herokuapp.com/contacts">
                            <svg className="bi" width="24" height="24">
                            </svg>
                        </a></li>
                        <li className="ms-3"><a className="link-dark" href="https://vertexstudio.herokuapp.com/contacts">
                            <svg className="bi" width="24" height="24">
                            </svg>
                        </a></li>
                    </ul>
                </div>
            </footer>
        </div>
    );
};
